import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-funeral-parlour-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-funeral-parlour-cm.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { AppControllerService } from "../../../../app-controller.service";
import { RecipientService } from "../../../../shared/components/recipient-components/shared/shared-services/recipient.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { ViewApplicationBaseComponent } from "../../../../view-application/shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { CreateFuneralParlourConstants } from "../../../../create-application/modules/cm/create-funeral-parlour-cm/create-funeral-parlour.constant";
let ViewFuneralParlourCmComponent = class ViewFuneralParlourCmComponent extends ViewApplicationBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    recipientService;
    selectedApplicationService;
    appService;
    changeDetectorRefs;
    appControllerService;
    routerParamsService;
    parlourForm = new FormGroup({});
    parlourGroups = [];
    parlourLabel = CreateFuneralParlourConstants.NOTICE_LABEL;
    parlourControl = CreateFuneralParlourConstants.PARLOUR_CONTROL;
    parlourSelectControl = CreateFuneralParlourConstants.PARLOUR_SELECT_CONTROL;
    validationMessages = CreateFuneralParlourConstants.VALIDATION_MESSAGES;
    title = CreateFuneralParlourConstants.TITLE;
    markFuneralParlourAsNotApplicableLabel = CreateFuneralParlourConstants.MARK_FUNERAL_PARLOUR_AS_NOT_APPLICABLE_LABEL;
    parlourMetadata;
    disableEditing = true;
    funeralParlourNotApplicableChecked = false;
    funeralParlourNotApplicableCheckboxDisabled = false;
    objectName = "view-funeral-parlour-details";
    selectedApplicationFPSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, recipientService, selectedApplicationService, appService, changeDetectorRefs, appControllerService, routerParamsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientService = recipientService;
        this.selectedApplicationService = selectedApplicationService;
        this.appService = appService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.appControllerService = appControllerService;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.listenForSelectedApplication();
        this.listenForRouteParamChange();
    }
    loadMetadata(stepMeta) {
        this.parlourMetadata = stepMeta;
        this.parlourGroups = stepMeta.funeralParlourGroup;
        this.listenForSelectedApplication();
        this.changeDetectorRefs.detectChanges();
    }
    handleRouteChange() {
    }
    listenForSelectedApplication() {
        this.selectedApplicationFPSubscription = this.selectedApplicationService.$selectedApplication.subscribe({
            next: (selectedApplication) => {
                if (selectedApplication) {
                    const selectedFuneralParlour = selectedApplication.funeralParlour;
                    if (selectedFuneralParlour && selectedFuneralParlour.length > 0) {
                        this.populateForm(selectedApplication);
                    }
                    else {
                        this.disableFields();
                    }
                    this.syncFuneralParlourNotApplicableCheckbox();
                }
            },
            error: (err) => {
                this.appControllerService.handleServerErrorMessage(this.objectName, err, CRUDOperation.Get);
            }
        });
    }
    initForm() {
        this.parlourForm = this.aflaModuleStrategyService.form.get("funeralParlourForm");
        this.parlourForm.enable();
    }
    populateForm(application) {
        this.parlourForm.get(this.parlourControl).patchValue(application.funeralParlour[0]);
        this.parlourForm.get(this.parlourSelectControl).patchValue(application.funeralParlourId);
    }
    syncFuneralParlourNotApplicableCheckbox() {
        const funeralParlourNotApplicable = this.selectedApplication.funeralParlourNa;
        if (funeralParlourNotApplicable) {
            this.funeralParlourNotApplicableChecked = true;
            this.parlourForm.get(this.parlourSelectControl).disable();
            this.parlourForm.get(this.parlourControl).disable();
            this.changeDetectorRefs.markForCheck();
        }
    }
    disableFields() {
        this.funeralParlourNotApplicableChecked = true;
        this.parlourForm.get(this.parlourSelectControl).disable();
        this.parlourForm.get(this.parlourControl).disable();
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: RecipientService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: AppControllerService },
        { type: RouterParamsService }
    ];
};
ViewFuneralParlourCmComponent = __decorate([
    Component({
        selector: "app-view-funeral-parlour-cm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewFuneralParlourCmComponent);
export { ViewFuneralParlourCmComponent };
